// src/services/saleApi.js
// API para reportes de ventas contables

import { dotoniwoofApi } from '../api/dotoniwooApi';

const BASE = '/sale.php';

const isSuccess = (code) => code === 200 || code === '200' || code === 201;

/**
 * Reporte de ventas contables por método de pago y categoría
 * GET sale.php/sale-report-accounting?year=YYYY&month=M&payment_methods[]=1&categories[]=1&page=1&limit=20
 * @param {number} year - Año (opcional, por defecto año actual)
 * @param {number} month - Mes 1-12 (opcional, por defecto mes actual)
 * @param {Array<number>|string} paymentMethods - IDs de métodos de pago (opcional, array o string separado por comas)
 * @param {Array<number>|string} categories - IDs de categorías (opcional, array o string separado por comas)
 * @param {number} page - Número de página (opcional, por defecto 1)
 * @param {number} limit - Resultados por página (opcional, por defecto 20, máximo 100)
 */
export async function getSaleReportAccounting(year, month, paymentMethods = [], categories = [], page = 1, limit = 20) {
  try {
    const params = {};
    if (year) params.year = year;
    if (month) params.month = month;
    if (limit != null && limit >= 0) params.limit = limit === 0 ? 0 : Math.min(limit, 100);
    if (limit > 0 && page) params.page = page;
    
    // Manejar payment_methods como array o string separado por comas
    if (paymentMethods && paymentMethods.length > 0) {
      if (Array.isArray(paymentMethods)) {
        paymentMethods.forEach((id, index) => {
          params[`payment_methods[${index}]`] = id;
        });
      } else if (typeof paymentMethods === 'string') {
        params.payment_methods = paymentMethods;
      }
    }
    
    // Manejar categories como array o string separado por comas
    if (categories && categories.length > 0) {
      if (Array.isArray(categories)) {
        categories.forEach((id, index) => {
          params[`categories[${index}]`] = id;
        });
      } else if (typeof categories === 'string') {
        params.categories = categories;
      }
    }
    
    const res = await dotoniwoofApi.get(`${BASE}/sale-report-accounting`, { params });
    const data = res.data;
    const hasData = Array.isArray(data?.data);
    const hasSummary = limit === 0 || hasData;
    
    if (isSuccess(data?.code) && hasSummary) {
      return {
        ok: true,
        year: data.year,
        month: data.month,
        filters: data.filters || {},
        total_rows: data.total_rows || 0,
        total_pages: data.total_pages || 1,
        page: data.page || page,
        limit: data.limit ?? limit,
        summary: Array.isArray(data.summary) ? data.summary : [],
        items: Array.isArray(data.data) ? data.data : []
      };
    }
    return {
      ok: false,
      year: year || new Date().getFullYear(),
      month: month || new Date().getMonth() + 1,
      filters: {},
      total_rows: 0,
      total_pages: 0,
      page: 1,
      limit: limit,
      summary: [],
      items: []
    };
  } catch (error) {
    console.error('getSaleReportAccounting error', error);
    return {
      ok: false,
      year: year || new Date().getFullYear(),
      month: month || new Date().getMonth() + 1,
      filters: {},
      total_rows: 0,
      total_pages: 0,
      page: 1,
      limit: limit,
      summary: [],
      items: []
    };
  }
}

/**
 * Obtiene solo el resumen por método de pago del mes (sin paginación).
 * Usa limit=0 para que el backend devuelva el resumen general del mes.
 */
export async function getSaleReportSummary(year, month, paymentMethods = [], categories = []) {
  return getSaleReportAccounting(year, month, paymentMethods, categories, 1, 0);
}
